export interface Comic {
  id: number;
  title: string;
  slug: string;
  category: string;
  coverImage: string;
  rating: number;
  author: string;
  status: string;
  shortDescription: string;
  views: number;
  updateDate: string;
  tags: string[];
}

export const comics: Comic[] = [
  {
    id: 1,
    title: "她的秘密花园",
    slug: "her-secret-garden",
    category: "romance",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20artwork%20romance%20cover%2C%20beautiful%20young%20couple%20in%20flower%20garden%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20clean%20illustration%20with%20warm%20lighting%2C%20Korean%20digital%20art%20style%2C%20vertical%20webtoon%20cover%20design%2C%20elegant%20and%20dreamy%20aesthetic%20on%20simple%20light%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    rating: 9.5,
    author: "金智媛",
    status: "连载中",
    shortDescription: "平凡女大学生意外继承了祖母的秘密花园，在那里遇见了神秘又迷人的园丁，一段穿越时空的浪漫故事就此展开。",
    views: 1280000,
    updateDate: "2026-08-04",
    tags: ["恋爱", "奇幻", "治愈", "校园"],
  },
  {
    id: 2,
    title: "剑与魔法之城",
    slug: "sword-and-magic-city",
    category: "fantasy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20art%20style%20fantasy%20cover%2C%20warrior%20holding%20glowing%20sword%20in%20magical%20floating%20city%2C%20epic%20fantasy%20illustration%20with%20dramatic%20lighting%2C%20Korean%20digital%20painting%20style%2C%20clean%20composition%20on%20simple%20dark%20background%2C%20detailed%20character%20design%2C%20atmospheric%20and%20mysterious&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    rating: 9.3,
    author: "李东旭",
    status: "连载中",
    shortDescription: "在魔法与剑并存的浮空城市中，一名失忆的剑士踏上寻找真相的旅程，却意外卷入王国间的千年纷争。",
    views: 980000,
    updateDate: "2026-08-03",
    tags: ["奇幻", "冒险", "战斗", "魔法"],
  },
  {
    id: 3,
    title: "暗夜追踪者",
    slug: "night-tracker",
    category: "action",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20action%20cover%2C%20cool%20detective%20in%20leather%20jacket%20in%20neon%20lit%20city%20alley%20at%20night%2C%20noir%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20dramatic%20shadows%20and%20highlights%2C%20clean%20composition%20on%20simple%20dark%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    rating: 9.1,
    author: "朴灿烈",
    status: "已完结",
    shortDescription: "前特种兵成为私家侦探后，接手了一桩看似普通的失踪案，却逐渐揭开了一个横跨整个首尔的地下犯罪网络。",
    views: 1560000,
    updateDate: "2026-07-28",
    tags: ["动作", "悬疑", "犯罪", "都市"],
  },
  {
    id: 4,
    title: "第七个夜晚",
    slug: "the-seventh-night",
    category: "mystery",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20mystery%20cover%2C%20mysterious%20woman%20in%20foggy%20alley%20with%20old%20clock%20tower%20background%2C%20dark%20and%20atmospheric%2C%20Korean%20digital%20illustration%20style%2C%20cool%20tones%20with%20subtle%20warm%20accents%2C%20simple%20composition%20on%20dark%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    rating: 9.4,
    author: "郑秀晶",
    status: "连载中",
    shortDescription: "每当第七个夜晚来临，小镇上就会发生一起离奇死亡事件。女高中生韩素希发现自己能看见死者最后的记忆。",
    views: 1120000,
    updateDate: "2026-08-05",
    tags: ["悬疑", "推理", "超自然", "校园"],
  },
  {
    id: 5,
    title: "废柴逆袭日记",
    slug: "loser-revenge-diary",
    category: "comedy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20comedy%20cover%2C%20funny%20expressive%20office%20worker%20with%20exaggerated%20reaction%2C%20bright%20and%20colorful%2C%20playful%20Korean%20digital%20art%20style%2C%20humorous%20illustration%20on%20simple%20light%20background%2C%20cartoonish%20but%20polished&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    rating: 8.9,
    author: "宋多惠",
    status: "连载中",
    shortDescription: "职场底层的废柴青年某天获得了能看见他人好感度的超能力，从此开启了一系列啼笑皆非的逆袭之路。",
    views: 890000,
    updateDate: "2026-08-04",
    tags: ["搞笑", "职场", "超能力", "日常"],
  },
  {
    id: 6,
    title: "月光下的约定",
    slug: "promise-under-moonlight",
    category: "bl",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20romance%20cover%2C%20two%20handsome%20young%20men%20standing%20under%20moonlight%20by%20window%2C%20soft%20and%20tender%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20warm%20and%20gentle%20color%20palette%2C%20elegant%20composition%20on%20simple%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    rating: 9.2,
    author: "柳成烈",
    status: "连载中",
    shortDescription: "音乐学院的两位天才少年，在月光下许下的约定，伴随着成长与分离，最终能否在命运的安排下重逢？",
    views: 1450000,
    updateDate: "2026-08-03",
    tags: ["耽美", "音乐", "校园", "治愈"],
  },
  {
    id: 7,
    title: "命运之轮",
    slug: "wheel-of-fate",
    category: "drama",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20drama%20cover%2C%20elegant%20woman%20in%20traditional%20hanbok%20standing%20before%20palace%20gate%2C%20historical%20and%20emotional%20atmosphere%2C%20Korean%20digital%20painting%20style%2C%20warm%20and%20rich%20colors%2C%20cinematic%20composition%20on%20simple%20background&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    rating: 9.6,
    author: "韩智慧",
    status: "已完结",
    shortDescription: "朝鲜王朝末期，贵族之女与平民画师之间跨越阶级的爱情故事，在动荡时代背景下谱写的悲欢离合。",
    views: 2100000,
    updateDate: "2026-06-15",
    tags: ["剧情", "历史", "爱情", "古装"],
  },
  {
    id: 8,
    title: "镜中怪谈",
    slug: "mirror-tales",
    category: "horror",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20horror%20cover%2C%20creepy%20reflection%20in%20broken%20mirror%20with%20dark%20figure%2C%20ominous%20and%20chilling%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20muted%20dark%20colors%20with%20subtle%20red%20accents%2C%20minimalist%20composition%20on%20dark%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    rating: 9.0,
    author: "金秀贤",
    status: "连载中",
    shortDescription: "搬进廉价公寓的独居女生发现房间里的镜子会在午夜显现另一个世界，而那个世界里的东西正试图穿越过来。",
    views: 760000,
    updateDate: "2026-08-05",
    tags: ["惊悚", "恐怖", "超自然", "都市传说"],
  },
  {
    id: 9,
    title: "甜蜜的谎言",
    slug: "sweet-lies",
    category: "romance",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20art%20style%20romance%20cover%2C%20cute%20couple%20sharing%20ice%20cream%20in%20spring%20cherry%20blossom%20street%2C%20sweet%20and%20fresh%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20pastel%20pink%20and%20white%20palette%2C%20clean%20composition%20on%20simple%20light%20background&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    rating: 8.8,
    author: "朴敏英",
    status: "连载中",
    shortDescription: "为了躲避相亲而谎称已有男友的女主角，不得不雇用隔壁冷淡的咖啡师扮演恋人，假戏真做的甜蜜故事。",
    views: 1020000,
    updateDate: "2026-08-04",
    tags: ["恋爱", "咖啡", "契约恋爱", "治愈"],
  },
  {
    id: 10,
    title: "龙骑士传说",
    slug: "legend-of-dragon-knight",
    category: "fantasy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20fantasy%20cover%2C%20dragon%20rider%20on%20epic%20dragon%20flying%20through%20clouds%20above%20medieval%20kingdom%2C%20grand%20and%20majestic%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20warm%20golden%20lighting%2C%20heroic%20composition%20on%20simple%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    rating: 9.4,
    author: "崔珉豪",
    status: "已完结",
    shortDescription: "龙族灭绝后的千年，少年偶然唤醒了最后一枚龙蛋，从此踏上成为龙骑士的传奇之路，对抗黑暗势力的史诗冒险。",
    views: 1870000,
    updateDate: "2026-05-20",
    tags: ["奇幻", "冒险", "龙", "战斗"],
  },
  {
    id: 11,
    title: "心跳加速器",
    slug: "heartbeat-accelerator",
    category: "romance",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20art%20style%20romance%20cover%2C%20young%20couple%20with%20headphones%20sharing%20music%20in%20cozy%20cafe%2C%20warm%20and%20intimate%20atmosphere%2C%20Korean%20digital%20illustration%2C%20soft%20brown%20and%20cream%20colors%2C%20simple%20composition%20on%20light%20background&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    rating: 9.0,
    author: "尹恩惠",
    status: "连载中",
    shortDescription: "听力障碍的钢琴调音师与声音主播之间，通过声音建立起的心灵连接，一段不需要言语的浪漫爱情。",
    views: 750000,
    updateDate: "2026-08-02",
    tags: ["恋爱", "音乐", "治愈", "都市"],
  },
  {
    id: 12,
    title: "拳拳到肉",
    slug: "fist-to-fist",
    category: "action",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20action%20cover%2C%20martial%20artist%20in%20fighting%20stance%20in%20underground%20arena%2C%20dynamic%20and%20powerful%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20bold%20red%20and%20black%20color%20scheme%2C%20intense%20composition%20on%20simple%20dark%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    rating: 8.7,
    author: "姜虎东",
    status: "连载中",
    shortDescription: "退役拳击手为了还清债务，重新踏入地下格斗场，每一拳都关系到生死存亡的残酷较量。",
    views: 680000,
    updateDate: "2026-08-03",
    tags: ["动作", "格斗", "热血", "地下拳击"],
  },
  {
    id: 13,
    title: "迷雾之岛",
    slug: "mist-island",
    category: "mystery",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20mystery%20cover%2C%20foggy%20island%20with%20old%20lighthouse%20and%20silhouetted%20figure%2C%20mysterious%20and%20eerie%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20cool%20gray%20and%20teal%20tones%2C%20minimalist%20composition%20on%20dark%20background&width=600&height=800&seq=comic-cover-13&orientation=portrait",
    rating: 9.1,
    author: "郑秀晶",
    status: "已完结",
    shortDescription: "六名陌生人受邀来到一座孤岛上的豪华别墅，暴风雨切断所有联系后，一场真实版狼人杀就此上演。",
    views: 1340000,
    updateDate: "2026-04-10",
    tags: ["悬疑", "推理", "孤岛", "密室"],
  },
  {
    id: 14,
    title: "社长大人请自重",
    slug: "mr-president-behave",
    category: "comedy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20comedy%20cover%2C%20funny%20office%20scene%20with%20serious%20boss%20and%20chaotic%20employee%2C%20bright%20and%20humorous%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20colorful%20and%20playful%2C%20clean%20composition%20on%20simple%20light%20background&width=600&height=800&seq=comic-cover-14&orientation=portrait",
    rating: 9.3,
    author: "宋多惠",
    status: "连载中",
    shortDescription: "当完美主义的冷面上司意外变成了公司的吉祥物玩偶，小秘书不得不在保守秘密的同时应付各种爆笑状况。",
    views: 1560000,
    updateDate: "2026-08-05",
    tags: ["搞笑", "职场", "变身", "日常"],
  },
  {
    id: 15,
    title: "深海之歌",
    slug: "song-of-the-deep",
    category: "drama",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20drama%20cover%2C%20woman%20diving%20into%20deep%20blue%20ocean%20with%20sunlight%20streaming%20through%20water%2C%20beautiful%20and%20melancholic%20atmosphere%2C%20Korean%20digital%20painting%20style%2C%20rich%20blue%20and%20golden%20colors%2C%20poetic%20composition%20on%20simple%20background&width=600&height=800&seq=comic-cover-15&orientation=portrait",
    rating: 9.5,
    author: "韩智慧",
    status: "连载中",
    shortDescription: "海女家族的最后一个传人，在深海中发现了祖先留下的秘密，一段关于家族、传承与自我救赎的故事。",
    views: 920000,
    updateDate: "2026-08-04",
    tags: ["剧情", "家族", "海洋", "人生"],
  },
  {
    id: 16,
    title: "红线牵缘",
    slug: "red-thread-of-fate",
    category: "bl",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20romance%20cover%2C%20two%20young%20men%20connected%20by%20red%20thread%20in%20park%20at%20sunset%2C%20warm%20and%20emotional%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20soft%20golden%20and%20rose%20colors%2C%20elegant%20composition%20on%20simple%20background&width=600&height=800&seq=comic-cover-16&orientation=portrait",
    rating: 9.4,
    author: "柳成烈",
    status: "已完结",
    shortDescription: "能看见姻缘红线的少年一直躲避着自己的命运，直到遇见了那个无论如何都剪不断的缘分。",
    views: 1880000,
    updateDate: "2026-03-28",
    tags: ["耽美", "超能力", "命运", "校园"],
  },
  {
    id: 17,
    title: "热血格斗高校",
    slug: "fighting-high-school",
    category: "action",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20action%20cover%2C%20high%20school%20students%20in%20martial%20arts%20tournament%20arena%2C%20energetic%20and%20dynamic%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20bold%20and%20saturated%20colors%2C%20action%20packed%20composition%20on%20simple%20background&width=600&height=800&seq=comic-cover-17&orientation=portrait",
    rating: 8.6,
    author: "姜虎东",
    status: "连载中",
    shortDescription: "转学生进入了一所以格斗实力决定地位的高中，从最底层开始，用双拳打出属于自己的天下。",
    views: 820000,
    updateDate: "2026-08-01",
    tags: ["动作", "校园", "格斗", "热血"],
  },
  {
    id: 18,
    title: "异世界食堂",
    slug: "isekai-restaurant",
    category: "fantasy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20fantasy%20cover%2C%20cozy%20restaurant%20with%20magical%20creatures%20and%20fantasy%20characters%20enjoying%20food%2C%20warm%20and%20inviting%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20rich%20warm%20colors%2C%20charming%20composition%20on%20simple%20light%20background&width=600&height=800&seq=comic-cover-18&orientation=portrait",
    rating: 9.2,
    author: "李东旭",
    status: "连载中",
    shortDescription: "一个普通厨师的后门突然连接到了异世界，各种奇幻生物纷纷慕名而来品尝人间美食的温馨故事。",
    views: 1100000,
    updateDate: "2026-08-04",
    tags: ["奇幻", "美食", "异世界", "治愈"],
  },
  {
    id: 19,
    title: "午夜诊所",
    slug: "midnight-clinic",
    category: "horror",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20horror%20cover%2C%20eerie%20medical%20clinic%20at%20night%20with%20mysterious%20doctor%20silhouette%2C%20creepy%20and%20suspenseful%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20dark%20green%20and%20black%20tones%2C%20minimalist%20composition%20on%20dark%20background&width=600&height=800&seq=comic-cover-19&orientation=portrait",
    rating: 8.9,
    author: "金秀贤",
    status: "连载中",
    shortDescription: "只在午夜开门的神秘诊所，治疗的不是普通疾病，而是人们心中最深层的恐惧和噩梦。",
    views: 650000,
    updateDate: "2026-08-03",
    tags: ["惊悚", "恐怖", "医疗", "心理"],
  },
  {
    id: 20,
    title: "她的反派生涯",
    slug: "her-villain-career",
    category: "drama",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20drama%20cover%2C%20elegant%20woman%20in%20business%20suit%20looking%20over%20city%20skyline%20at%20night%2C%20powerful%20and%20determined%20atmosphere%2C%20Korean%20digital%20painting%20style%2C%20cool%20and%20sophisticated%20colors%2C%20cinematic%20composition%20on%20simple%20dark%20background&width=600&height=800&seq=comic-cover-20&orientation=portrait",
    rating: 9.3,
    author: "朴敏英",
    status: "连载中",
    shortDescription: "被诬陷而失去一切的女检察官，以全新身份重返名利场，精心策划一场颠覆整个财阀集团的复仇大戏。",
    views: 1350000,
    updateDate: "2026-08-05",
    tags: ["剧情", "复仇", "职场", "女性"],
  },
  {
    id: 21,
    title: "猫咪咖啡厅",
    slug: "cat-cafe",
    category: "comedy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20comedy%20cover%2C%20cute%20cat%20cafe%20with%20many%20funny%20cats%20and%20chaotic%20owner%2C%20bright%20and%20cheerful%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20soft%20pastel%20colors%2C%20playful%20composition%20on%20simple%20light%20background&width=600&height=800&seq=comic-cover-21&orientation=portrait",
    rating: 8.8,
    author: "尹恩惠",
    status: "已完结",
    shortDescription: "对猫过敏却被迫经营猫咪咖啡厅的倒霉青年，与一群性格各异的猫咪和客人们的温馨搞笑日常。",
    views: 970000,
    updateDate: "2026-02-14",
    tags: ["搞笑", "猫", "日常", "治愈"],
  },
  {
    id: 22,
    title: "星辰坠落之夜",
    slug: "night-of-falling-stars",
    category: "fantasy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20fantasy%20cover%2C%20girl%20reaching%20toward%20falling%20stars%20in%20night%20sky%20from%20rooftop%2C%20magical%20and%20dreamy%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20deep%20blue%20and%20sparkling%20gold%20colors%2C%20poetic%20composition%20on%20simple%20dark%20background&width=600&height=800&seq=comic-cover-22&orientation=portrait",
    rating: 9.1,
    author: "崔珉豪",
    status: "连载中",
    shortDescription: "天文台实习生偶然发现坠落人间的星辰化作了人形，一段人类与星辰之子的奇幻邂逅与守护之旅。",
    views: 870000,
    updateDate: "2026-08-02",
    tags: ["奇幻", "天文", "守护", "治愈"],
  },
  {
    id: 23,
    title: "完美犯罪教科书",
    slug: "perfect-crime-textbook",
    category: "mystery",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20mystery%20cover%2C%20crime%20scene%20investigation%20with%20forensic%20clues%20and%20detective%20notes%2C%20tense%20and%20intellectual%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20muted%20cool%20colors%2C%20clean%20and%20methodical%20composition%20on%20simple%20dark%20background&width=600&height=800&seq=comic-cover-23&orientation=portrait",
    rating: 9.5,
    author: "朴灿烈",
    status: "连载中",
    shortDescription: "犯罪心理学教授与他的天才学生们，通过分析历史上最完美的犯罪案例来侦破当下正在发生的连环案件。",
    views: 1430000,
    updateDate: "2026-08-04",
    tags: ["悬疑", "犯罪心理", "推理", "学术"],
  },
  {
    id: 24,
    title: "灵魂画师",
    slug: "soul-painter",
    category: "drama",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20drama%20cover%2C%20artist%20painting%20with%20passion%20in%20studio%20filled%20with%20colorful%20canvases%2C%20emotional%20and%20artistic%20atmosphere%2C%20Korean%20digital%20painting%20style%2C%20rich%20and%20vibrant%20colors%2C%20expressive%20composition%20on%20simple%20background&width=600&height=800&seq=comic-cover-24&orientation=portrait",
    rating: 9.4,
    author: "韩智慧",
    status: "已完结",
    shortDescription: "失明的天才画家通过触摸感知色彩，她所画出的每一幅画都承载着一个人生故事，治愈自己也治愈他人。",
    views: 1760000,
    updateDate: "2026-01-30",
    tags: ["剧情", "艺术", "治愈", "人生"],
  },
];